@if (overrideCssUrl) {
  <link rel="stylesheet" type="text/css" [href]="overrideCssUrl | safeUrl">
}

<loan-update-conflict-notification></loan-update-conflict-notification>

@if (userIsImpersonating) {
  <div class="alert alert-light fade show mb-1 navbar-expand-lg" role="alert"
    id="alert-window" style="position: relative !important; border-bottom: 2px solid rgb(46, 168, 226) !important;">
    <div class="media">
      <i style="color:rgb(46, 168, 226)" class="fas fa-diagnoses alert-icon align-self-center font-30 me-3"></i>
      <div class="media-body align-self-center">
        <span class="mb-1 fw-bold mt-0">You are currently viewing the Admin Portal in impersonation mode.</span><br>
        <span> <a (click)="onStopImpersonatingClicked()" (keyup.enter)="onStopImpersonatingClicked()" tabindex="0" style="color:rgb(46, 168, 226)" target="_blank">Click Here To
        Stop Impersonating</a></span>
      </div>
    </div>
  </div>
}

@if (showVoiceProfileBanner) {
  <div class="alert alert-warning fade show mb-1 navbar-expand-lg d-none d-md-block" role="alert"
    id="voice-profile-banner" style="position: relative !important; border-bottom: 2px solid #f0ad4e !important;">
    <div class="media">
      <i style="color: #f0ad4e" class="fas fa-microphone alert-icon align-self-center font-30 me-3"></i>
      <div class="media-body align-self-center flex-grow-1">
        <span class="mb-1 fw-bold mt-0">Voice Profile Recording Needed</span><br>
        <span>You have {{voiceProfileCampaignNames.length}} active campaign(s) using personalized voice
          @if (voiceProfileCampaignNames.length > 0) {
            ({{voiceProfileCampaignNames.join(', ')}})
          }
          . Record your voice profile to enable them.</span>
      </div>
      <div class="d-flex align-items-center ms-3">
        <button class="btn btn-warning btn-sm me-2" (click)="onRecordVoiceProfileClicked()">
          <i class="fas fa-microphone me-1"></i>Record Now
        </button>
        <button class="btn btn-outline-secondary btn-sm" (click)="onDismissVoiceProfileBanner()">
          Dismiss
        </button>
      </div>
    </div>
  </div>
}

<admin-header
  [user]="user"
  [brandLogoUrl]="brandLogoUrl"
  [brandSmallLogoUrl]="brandSmallLogoUrl"
  (mentionsClicked)="onMentionsStreamToggled($event)"
  (niceInContactClicked)="onNiceInContactToggled($event)"
  (notificationsClicked)="onNotificationsToggled($event)"
  (alertsCreated)="onAlertsCreated($event)"
  (conversationsToggled)="onConversationsToggled($event)"
  (testAudioSettingsClicked)="onTestAudioSettingsToggled()"
  [unreadConversations]="_hasUnreadConversations"
  (newLeadClicked)="onNewLeadToggled()"
  (newAgentClicked)="onNewAgentToggled()"
  (newContactClicked)="onNewContactToggled()"
  (newApplicationClicked)="onNewApplicationToggled()"
  (viewLeadClicked)="viewViewLeadModal($event?.leadId)"
  (dialpadClicked)="onDialpadToggled()"
  (viewAgentClicked)="onEditRequestedForAgent($event)">
</admin-header>

<!-- Top call bar hidden - all VoIP controls now in left slideout panel -->
<div class="row" [hidden]="true">
  <div class="d-flex flex-sm-column align-items-md-start bg-white">
    @if (usingPanelType === 'classic') {
      <call-control-panel-action-bar></call-control-panel-action-bar>
    }
  </div>
</div>

<!-- g-0: this row's parent has no horizontal padding, so a gutter's negative margins would push it
     past the viewport and give every page a small horizontal scroll. With no gutter the row is
     exactly the viewport width and its columns have no gutter padding, so page content is unchanged. -->
<div class="row g-0">
  @if (niceInContactVisible) {
    <div class="col-md-3 pe-0">
      <div id="niceInContact" class="card" style="height: calc(100vh - 53px);position: sticky;top: 53px;border-radius: 0;">
        <div class="card-body px-2" style="height: 100%; padding-top: 0.75rem;">
          <div class="row" style="height: 100%;">
            <div class="col-md-12 d-flex flex-column" style="height: 100%; overflow-y: hidden;">
              <div class="d-flex align-items-center">
                <ul class="nav nav-tabs flex-grow-1">
                  <li class="nav-item">
                    <a class="nav-link" [ngClass]="{'active': currentTab === 'ring-central'}"
                      (click)="currentTab = 'ring-central';" (keyup.enter)="currentTab = 'ring-central';" tabindex="0">
                      Ring Central (Phone)
                    </a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link" [ngClass]="{'active': currentTab === 'nice-in-contact'}"
                      (click)="currentTab = 'nice-in-contact';" (keyup.enter)="currentTab = 'nice-in-contact';" tabindex="0">
                      Nice In Contact (Dialer)
                    </a>
                  </li>
                </ul>
                <button type="button" class="btn-close slideout-close-btn-inline ms-2"
                  (click)="onNiceInContactClosed()" aria-label="Close Nice In Contact panel"></button>
              </div>
              <div class="nice-in-contact-divider"></div>
              <div class="tab-content flex-grow-1 overflow-hidden">
                @if (currentTab === 'ring-central') {
                  <div style="height: 100%;">
                    <iframe height="100%" width="100%" id="rc-widget" allow="microphone"
                      src="https://apps.ringcentral.com/integration/ringcentral-embeddable/latest/app.html?clientId=6DJ7cVVHsgldD3cvWNDWQJ&appServer=https://platform.devtest.ringcentral.com&redirectUri=https://advantage1st.lodasoft.com/">
                    </iframe>
                  </div>
                }
                @if (currentTab === 'nice-in-contact') {
                  <div style="height: 100%;">
                    <iframe height="100%" width="100%" src="https://cxagent.nicecxone.com/home?app=cxa"></iframe>
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  }

  <!-- Dialpad slideout panel - always rendered for VoIP components to receive events, hidden when not visible -->
  <div class="col-md-3 pe-0" [hidden]="!dialpadVisible">
    <div id="dial-a-number" class="card dialpad-slideout-card">
      <div class="card-body dialpad-slideout-body">
        <button type="button" class="btn-close slideout-close-btn" (click)="onDialpadToggled()" aria-label="Close dialpad panel"></button>
        <ul class="nav nav-tabs dialpad-tabs">
          <li class="nav-item">
            <a class="nav-link" [ngClass]="{'active': dialpadActiveTab === 'dialpad'}"
              (click)="dialpadActiveTab = 'dialpad'" (keyup.enter)="dialpadActiveTab = 'dialpad'" tabindex="0">
              <i-lucide name="grid-3x3" [size]="16" [strokeWidth]="2"></i-lucide>
              <span>Dialpad</span>
            </a>
          </li>
            @if (hasCallControlPanelActionBar) {
              <li class="nav-item">
                <a class="nav-link" [ngClass]="{'active': dialpadActiveTab === 'active-call'}"
                  (click)="dialpadActiveTab = 'active-call'" (keyup.enter)="dialpadActiveTab = 'active-call'" tabindex="0">
                  <i-lucide name="phone-call" [size]="16" [strokeWidth]="2"></i-lucide>
                  <span>Active Call</span>
                  <span class="live-badge">
                    <span class="live-dot"></span>
                    Live
                  </span>
                </a>
              </li>
            }
        </ul>
        <div class="tab-content dialpad-tab-content">
          <div class="dialpad-tab-pane" [hidden]="dialpadActiveTab !== 'dialpad'">
            <dial-number-and-call-history
              [panelType]="usingPanelType"
              [showCallControls]="false"
              (closeDialClicked)="onDialpadToggled()">
            </dial-number-and-call-history>
          </div>
          <!-- VoIP components - always rendered to receive dialer events, hidden when not on Active Call tab -->
          @if (usingPanelType === 'twilio') {
            <div class="active-call-tab-pane" [hidden]="dialpadActiveTab !== 'active-call'">
              <twilio-call-control-panel-action-bar [displayMode]="'slideout'"></twilio-call-control-panel-action-bar>
            </div>
          }
          @if (usingPanelType === 'ringCentral') {
            <div class="active-call-tab-pane" [hidden]="dialpadActiveTab !== 'active-call'">
              <ring-central-call-control-panel [displayMode]="'slideout'"></ring-central-call-control-panel>
            </div>
          }
          @if (usingPanelType === 'classic' && dialpadActiveTab === 'active-call' && hasCallControlPanelActionBar) {
            <div class="active-call-tab-pane">
              <dial-number-and-call-history
                [panelType]="'classic'"
                [showCallControls]="true"
                [showDialpad]="false"
                (closeDialClicked)="onDialpadToggled()">
              </dial-number-and-call-history>
            </div>
          }
        </div>
      </div>
    </div>
  </div>

    <div class="main-content-area" [ngClass]="{'col-md-9 ps-0' : niceInContactVisible || dialpadVisible, 'col-md-12' : !niceInContactVisible && !dialpadVisible }">
      <router-outlet></router-outlet>
    </div>
</div>
<!-- <call-control-panel></call-control-panel> -->

<lead-route-leads></lead-route-leads>

<drawer [title]="'New Lead'" [name]="'newLeadDrawer'" [templateRef]="newLeadContentRef" [footerActionsRef]="newLeadFooterRef" [options]="newLeadDrawerOptions"
  (closed)="onNewLeadDrawerClosed()">
</drawer>
<ng-template #newLeadContentRef>
  <lead-editor #leadEditor (newLeadAdded)="onNewLeadDrawerClose($event)" (closeDrawer)="onNewLeadCancelled()"
    (footerStateChanged)="onNewLeadFooterStateChanged($event)">
  </lead-editor>
</ng-template>
<ng-template #newLeadFooterRef>
  <div class="d-flex align-items-center justify-content-end gap-2">
    <button
      type="button"
      class="btn btn-secondary"
      (click)="onNewLeadCancelled()">
      <i class="fa-solid fa-times"></i> Cancel
    </button>
    <button
      type="button"
      class="btn btn-primary"
      [disabled]="!newLeadFooterState.canSubmit"
      (click)="saveNewLeadFromFooter()">
      @if (!newLeadFooterState.saving) {
        <span><i class="fa-solid fa-save me-2"></i>Save</span>
      }
      @if (newLeadFooterState.saving) {
        <span>
          <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          Saving
        </span>
      }
    </button>
  </div>
</ng-template>

<drawer [title]="'New Agent'" [name]="'newAgentDrawer'" [templateRef]="newAgentContentRef"
  [subHeaderActionsRef]="newAgentSubHeaderState.showTabs ? newAgentDrawerSubHeaderRef : null"
  [footerActionsRef]="newAgentFooterState.showFooter ? newAgentDrawerFooterRef : null"
  [options]="newAgentDrawerOptions" (closed)="onNewAgentDrawerClosed()">
</drawer>
<ng-template #newAgentContentRef>
  <upsert-agent #newUpsertAgent [agentId]="0" [isDrawer]="true"
    (footerStateChanged)="onNewAgentFooterStateChanged($event)"
    (subHeaderStateChanged)="onNewAgentSubHeaderStateChanged($event)"
    (onAddEditAgent)="onNewAgentDrawerClose($event)"
    (closeDrawer)="onNewAgentDrawerClose()">
  </upsert-agent>
</ng-template>
<ng-template #newAgentDrawerSubHeaderRef>
  <agent-drawer-subheader [subHeaderState]="newAgentSubHeaderState"
    (tabSelected)="selectNewAgentDrawerTab($event)"
    (wizardUrlSelected)="copyNewAgentWizardUrl($event)">
  </agent-drawer-subheader>
</ng-template>
<ng-template #newAgentDrawerFooterRef>
  <agent-drawer-footer [footerState]="newAgentFooterState" [activeTab]="newAgentSubHeaderState.activeTab"
    (cancelClicked)="closeNewAgentDrawerFromFooter()"
    (notesContentChanged)="updateNewAgentNotesDraft($event)"
    (saveClicked)="saveNewAgentFromFooter()"
    (saveAndCloseClicked)="saveAndCloseNewAgentFromFooter()"
    (saveAndInviteClicked)="saveAndInviteNewAgentFromFooter()">
  </agent-drawer-footer>
</ng-template>

<drawer [title]="'New Contact'" [name]="'newContactDrawer'" [templateRef]="newContactContentRef"
  [footerActionsRef]="newContactDrawerFooterRef"
  [options]="newContactDrawerOptions" (closed)="onNewContactDrawerClosed()">
</drawer>
<ng-template #newContactContentRef>
  <new-contact #newContactComponent [isDrawer]="true" (closeDrawer)="onNewContactDrawerClose()"
    (contactCreated)="onNewContactCreated($event)"
    (footerStateChanged)="onNewContactFooterStateChanged($event)">
  </new-contact>
</ng-template>
<ng-template #newContactDrawerFooterRef>
  <div class="d-flex justify-content-end align-items-center gap-2 flex-wrap">
    <button type="button" class="btn btn-secondary" (click)="closeNewContactDrawerFromFooter()">
      <i class="fa-solid fa-times"></i> Cancel
    </button>
    <button type="button" class="btn btn-primary" [disabled]="!newContactFooterState.canSubmit"
      (click)="saveNewContactFromFooter()">
      @if (!newContactFooterState.saving) {
        <span><i class="fa-solid fa-save"></i> Save</span>
      }
      @if (newContactFooterState.saving) {
        <span>
          <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        </span>
      }
    </button>
  </div>
</ng-template>

<drawer [title]="'New Application'" [name]="'newApplicationDrawer'" [templateRef]="newApplicationContentRef"
  [options]="newApplicationDrawerOptions" (closed)="onNewApplicationDrawerClosed()">
</drawer>
<ng-template #newApplicationContentRef>
  <new-application (closeDrawer)="onNewApplicationDrawerClose()"></new-application>
</ng-template>

<drawer #mentionsDrawer [title]="'Mentions'" [name]="'mentionsDrawer'" [templateRef]="mentionsDrawerContentRef"
  [options]="mentionsDrawerOptions" (closed)="onMentionsDrawerClosed()">
</drawer>
<ng-template #mentionsDrawerContentRef>
  <mentions-stream (mentionClicked)="onMentionClicked($event)"></mentions-stream>
</ng-template>

<drawer [title]="'Alerts & Notifications'" #alerts [name]="'alertsDrawer'" [templateRef]="alertsDrawerContentRef"
  [options]="alertsDrawerOptions" (closed)="onNotificationsDrawerClosed()">
</drawer>
<ng-template #alertsDrawerContentRef>
  <notifications-list [data]="notifications" (clickedGotoDetails)="notificationDetails($event)">
  </notifications-list>
</ng-template>

<drawer [title]="'Loan Activity'" [options]="loanActivityDrawerOptions" [name]="'loanActivityInternalMessageDrawer'"
  [templateRef]="loanActivityRef" (closed)="onMentionDetailsDrawerClosed()">
</drawer>
<ng-template #loanActivityRef>
  <div class="drawer-fill">
    @if (mentionMessageScope === 'InternalMessage') {
      <loan-activity class="drawer-fill" [refreshMentions]="refreshMentions" [idOfMessageToScrollTo]="messageId" [showFilters]="true"
        [activityTab]="'InternalMessage'" [appId]="mentionApplicationId" [mentionTrackingGuid]="mentionTrackingGuid"
        >
      </loan-activity>
    }
  </div>
</ng-template>

<drawer [title]="'Editing Task'" [options]="taskEditorDrawerOptions" [name]="'taskEditorDrawer'"
[templateRef]="taskEditorRef" (closed)="onMentionDetailsDrawerClosed()"></drawer>
<ng-template #taskEditorRef>
  @if (taskMentionTrackingUrl) {
    <img [src]="taskMentionTrackingUrl" class="tracker-image" width="1" height="1" alt="">
  }
  @if (mentionMessageScope === 'TaskNote' && mentionLoanDocTask) {
    <task-editor style="height: 90%"
    [hostedInModal]="false" [refreshMentions]="refreshMentions" [task]="mentionLoanDocTask"></task-editor>
  }
</ng-template>

<drawer [title]="'Conversations'" [name]="'conversationsDrawer'" [templateRef]="conversationsContentRef"
  [headerActionsRef]="conversationsHeaderActionsRef"
  [options]="conversationsDrawerOptions" (closed)="onConversationsDrawerClosed()">
</drawer>
<ng-template #conversationsHeaderActionsRef>
  <button class="close-button me-1" (click)="onPopoutConversationsClicked()"
    [ngbTooltip]="'Open in new window'" placement="bottom">
    <i-lucide name="square-arrow-out-up-right" [size]="16" [strokeWidth]="2"></i-lucide>
  </button>
</ng-template>
<ng-template #conversationsContentRef>
  <conversations-panel
    #conversationList
    [doInitializeWithSavedFilters]="doInitializeConversationsWithSavedFilters"
    [allConversations]="allConversations"
    [globalConfig]="globalConfig"
    [conversationActivationRequest]="conversationActivationRequest"
    [userId]="conversationsUserId"
    (editAgent)="onEditRequestedForAgent($event)"
    (editLead)="onEditRequestedForLeadId($event)"
    (editBorrower)="onEditRequestedForContact($event)"
    (openApplication)="onOpenApplicationFromConversations($event)"
    (impersonatedUserChanged)="onImpersonatedUserChanged($event)"
    (allMarkedAsRead)="onAllConversationsMarkedAsRead($event)"
    (conversationReadStatusChanged)="onConversationReadStatusChanged($event)"
    [borrowerId]="alertBorrowerId">
  </conversations-panel>
</ng-template>

<drawer [title]="'Edit Agent'" #editAgentDrawer [name]="'editAgentDrawer'" [templateRef]="editAgentContentRef"
  [subHeaderActionsRef]="editAgentSubHeaderState.showTabs ? editAgentDrawerSubHeaderRef : null"
  [footerActionsRef]="editAgentFooterState.showFooter ? editAgentDrawerFooterRef : null"
  [options]="editAgentDrawerOptions" (closed)="onEditAgentDrawerClosed()">
</drawer>
<ng-template #editAgentContentRef>
  <upsert-agent #editUpsertAgent [agentId]="agentIdToEdit" [isDrawer]="true" [tab]="editAgentTab"
    (footerStateChanged)="onEditAgentFooterStateChanged($event)"
    (subHeaderStateChanged)="onEditAgentSubHeaderStateChanged($event)"
    (closeDrawer)="onEditAgentDrawerClose()">
  </upsert-agent>
</ng-template>
<ng-template #editAgentDrawerSubHeaderRef>
  <agent-drawer-subheader [subHeaderState]="editAgentSubHeaderState"
    (tabSelected)="selectEditAgentDrawerTab($event)"
    (wizardUrlSelected)="copyEditAgentWizardUrl($event)">
  </agent-drawer-subheader>
</ng-template>
<ng-template #editAgentDrawerFooterRef>
  <agent-drawer-footer [footerState]="editAgentFooterState" [activeTab]="editAgentSubHeaderState.activeTab"
    (cancelClicked)="closeEditAgentDrawerFromFooter()"
    (notesContentChanged)="updateEditAgentNotesDraft($event)"
    (saveClicked)="saveEditAgentFromFooter()"
    (saveAndCloseClicked)="saveAndCloseEditAgentFromFooter()">
  </agent-drawer-footer>
</ng-template>

<drawer [title]="'Edit Lead'" #editLeadDrawer [name]="'editLeadDrawer'" [options]="editLeadDrawerOptions"
  [footerActionsRef]="editLeadFooterRef"
  (opened)="onEditLeadDrawerOpened()" (closed)="onEditLeadDrawerClosed()"
  (componentLoaded)="onEditLeadComponentLoaded($event)">
</drawer>
<ng-template #editLeadFooterRef>
  <div class="d-flex align-items-center justify-content-end gap-2">
    @if (editLeadFooterState.mode === 'activity-note') {
      <button
        type="button"
        class="btn btn-secondary"
        [disabled]="editLeadFooterState.saving"
        (click)="cancelActivityNoteFromFooter()">
        <i class="fa-solid fa-times"></i> Cancel
      </button>
      <button
        type="button"
        class="btn btn-primary"
        [disabled]="!editLeadFooterState.canSubmit"
        (click)="saveActivityNoteFromFooter()">
        @if (!editLeadFooterState.saving) {
          <span><i class="fa-solid fa-save me-2"></i>Save Note</span>
        }
        @if (editLeadFooterState.saving) {
          <span>
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            Saving
          </span>
        }
      </button>
    } @else {
      <button
        type="button"
        class="btn btn-secondary"
        (click)="closeEditLeadDrawerFromFooter()">
        <i class="fa-solid fa-times"></i> Cancel
      </button>
      <button
        type="button"
        class="btn btn-primary"
        [disabled]="!editLeadFooterState.canSubmit"
        (click)="saveEditLeadFromFooter()">
        @if (!editLeadFooterState.saving) {
          <span><i class="fa-solid fa-save me-2"></i>Save</span>
        }
        @if (editLeadFooterState.saving) {
          <span>
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            Saving
          </span>
        }
      </button>
    }
  </div>
</ng-template>

<drawer [title]="'Edit Contact'" #editContactDrawer [name]="'editContactDrawer'" [templateRef]="editContactContentRef"
  [options]="editContactDrawerOptions" (closed)="onEditContactDrawerClosed()">
</drawer>
<ng-template #editContactContentRef>
  <borrower-editor [borrowerId]="borrowerIdToEdit" (borrowerSaved)="onEditContactDrawerClose()"
    (borrowerEditCancelled)="onEditContactDrawerClose()">
  </borrower-editor>
</ng-template>

<drawer [title]="'Generic Drawer'" #genericDrawer [name]="'genericDrawer'" [options]="genericDrawerOptions">
</drawer>

<drawer [title]="'Test Audio Settings'" [name]="'testAudioSettingsDrawer'"
  [templateRef]="testAudioSettingsRef" [options]="testAudioSettingsDrawerOptions"
  (closed)="onTestAudioSettingsDrawerClosed()">
</drawer>
<ng-template #testAudioSettingsRef>
  <test-audio-settings></test-audio-settings>
</ng-template>

<favicon-loader [faviconUrl]="faviconUrl"></favicon-loader>
